import { forwardRef, type HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { cva, type VariantProps } from 'class-variance-authority';
import cn from 'classnames';

const subtitleVariant = cva('', {
  variants: {
    size: {
      base: 'text-[1rem]',
    },
    weight: {
      bold: 'font-bold',
    },
  },
});

interface SplitSubtitleProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof subtitleVariant> {
  text: string;
  classNames?: {
    text?: string;
    line?: string;
  };
}

const SplitSubtitle = forwardRef<HTMLDivElement, SplitSubtitleProps>(
  ({ size, text = 'base', weight = 'bold', classNames, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <div
        ref={ref}
        {...props}
        className={cn(
          props.className,
          'flex items-center gap-4 w-full justify-center',
        )}
      >
        {/* <span className={cn(css.line, classNames?.line)}></span> */}
        <span
          className={cn(
            subtitleVariant({ size, weight }),
            classNames?.text,
            'leading-none',
          )}
        >
          {t(text)}
        </span>
        {/* <span className={cn(css.line, classNames?.line)}></span> */}
      </div>
    );
  },
);

export { SplitSubtitle };
